module.exports = __webpack_public_path__ + "static/media/nathania.64df5d52.jpg";